module.exports = __webpack_public_path__ + "static/media/barreira.37c41ab6.png";